<script>
import Layout from '../../layouts/main'
import PageHeader from "@/components/page-header";
import { GridComponent, ColumnsDirective, ColumnDirective,
  Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import api from "@/axios";
import moment from "moment";
import Loader from "@/router/views_mobagile/components/loader.vue";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  components: {
    Loader, Layout, PageHeader,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
  },
  data() {

    return {
      title: "Pesquisa Dados Públicos",
      items: [
        {
          text: "Clientes",
          href: "/"
        },
        {
          text: "Pesquisa Dados Públicos",
          active: true
        }
      ],
      dataList: null,
      loading: true,
      showModalPessoa: false,
      pessoaData: {},
      pessoaSociosData: null,

      pesqData: {
        'order': 'capital',
        'sentido': 'desc'
      },
      showModalPesquisa: false,
      restricaoDemo: null,

      filterSettings: { type: 'Excel' },
      toolbar: [
        { tooltipText: 'Nova Pesquisa', prefixIcon: 'e-search', id: 'novaPesq', align: 'Left' },
        { tooltipText: 'Novo Lead', prefixIcon: 'e-filter', id: 'novoLead', align: 'Left' },
        { tooltipText: 'Exportar Excel', prefixIcon: 'e-export-excel', id: 'exportExcel', align: 'Left' },
        { tooltipText: 'Exportar CSV', prefixIcon: 'e-export-csv', id: 'exportCsv', align: 'Left' },
        { text: 'Search', tooltipText: 'Pesquisar'}
      ],

      pageSettings: {
        pageSize: 20,
        currentPage: 1,
        totalRecordsCount: 0,
        pageSizes: ['20', '100', '200']
      },

      colsExib: [
        {
          type: "checkbox",
          headerText: "",
          textAlign: "Left",
        },
        {
          name: "capital",
          field: "Capital",
          headerText: "Capital",
          textAlign: "Right",
          template: "templtcapital",
        },
        {
          field: "cnpj",
          headerText: "CNPJ",
          textAlign: "Left",
        },
        {
          field: "nome",
          headerText: "Nome",
          textAlign: "Left",
          maxWidth: 450,
        },
        {
          field: "fantasia",
          headerText: "Fantasia",
          textAlign: "Left",
          maxWidth: 450,
        },
        {
          field: "bairro",
          headerText: "Bairro",
          textAlign: "Left",
        },
        {
          field: "endereco",
          headerText: "Endereço",
          textAlign: "Left",
        },
        {
          field: "telefone_1",
          headerText: "Telefone",
          textAlign: "Left",
        },
        {
          field: "email",
          headerText: "E-mail",
          textAlign: "Left",
        },
        {
          field: "@timestamp",
          headerText: "Data",
          textAlign: "Right",
          format: "dd/MM/yyyy"
        },

      ]


    };
  },

  created() {

  },

  mounted() {
    console.log('mounted clientes-pesquisa_0')
    this.atualizaDataList(1, 20)
  },

  provide: {
    grid: [Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport]
  },

  methods: {

    avisoDemonstracao(){
      console.log('avisoDemonstracao')
      if (this.restricaoDemo === true) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Restrição a 10 empresas, favor entrar em contato com setor comercial para liberação do módulo por completo.",
          showConfirmButton: false,
          timer: 3500
        })
      }
    },
    

    changePage(args){
      console.log('changePage')
      if (args.currentPage){
        console.log(args)
        this.atualizaDataList(args.currentPage, args.pageSize)
      }
    },

    confirmarNovaPesq(){
      console.log('confirmarNovaPesq')
      this.showModalPesquisa = false
      this.atualizaDataList(1, this.pageSettings.pageSize)
    },

    recordDoubleClick(evt){
      console.log('recordDoubleClick')
      console.log(evt.rowData);
      this.pessoaData = evt.rowData
      let sociosDt = []
      let contItens = 0
      console.log(this.pessoaData['x_socio_cnpj'])
      this.pessoaData['x_socio_cnpj'].forEach((socio) => {
        console.log(socio)
        sociosDt.push({
          'cnpj': this.pessoaData['x_socio_cnpj'][contItens],
          'nome': this.pessoaData['x_socio_nome'][contItens],
          'entrada': moment(this.pessoaData['x_socio_entrada'][contItens]).format('DD/MM/YYYY'),
          'faixaEtaria': this.pessoaData['x_socio_faixa_etaria'][contItens],
          'qualif': this.pessoaData['x_socio_qualif'][contItens],
          'repLegal': this.pessoaData['x_socio_repres_legal'][contItens],

        })
        contItens++
      })

      this.pessoaSociosData = sociosDt
      this.showModalPessoa = true
    },

    atualizaDataList(page, pageSize){
      console.log('atualizaDataList_cli')
      this.loading = true
      const paramsReq = {
        'cidade': this.pesqData.cidade,
        'estado': this.pesqData.estado,
        'cnae': this.pesqData.cnae,
        'nome': this.pesqData.nome,
        'socio': this.pesqData.socio,
        'bairro': this.pesqData.bairro,
        'rua': this.pesqData.rua,
        'cnpj': this.pesqData.cnpj,
        'page': page,
        'pageSize': pageSize,
        'order': this.pesqData.order,
        'sentido': this.pesqData.sentido
      }
      api.get(`${getBaseUrl()}api/elkempresas`, {
        params: paramsReq,
      }).then(response => {
        console.log('response.data')
        // console.log(response.data)
        if (response.data[2] === 'restricao') {
          this.restricaoDemo = true
        } else {
          this.restricaoDemo = false
        }
        const totalEmpresas = response.data[1]
        let dtList0 = []
        response.data[0].forEach((value) => {
          value['_source']['@timestamp'] = moment(value['_source']['@timestamp']).format('DD/MM/YYYY')
          value['_source']['id'] = value['_id']
          dtList0.push(value['_source'])
        })
        this.dataList = {
          result: dtList0,
          count: totalEmpresas,
        }
        this.loading = false

        this.title = `(${totalEmpresas}) Pesquisa Dados Públicos`
        if (this.restricaoDemo === true){
          this.title += ' (DEMONSTRAÇÃO)'
        }

        this.pageSettings.totalRecordsCount = totalEmpresas
        this.pageSettings.currentPage = page
        this.pageSettings.pageSize = pageSize
      })
    },

    dataBound: function() {
      this.$refs.dataGrid.autoFitColumns([])
    },

    tbClickHandler: function(args) {
      console.log('tbClickHandler')
      if (args.item.id === 'novaPesq') {
        console.log('novaPesq')
        this.showModalPesquisa = true
      }else if (args.item.id === 'novoLead') {
        // console.log('novoLead')
        const selectedRecords = this.$refs.dataGrid.getSelectedRecords();
        if (selectedRecords.length > 0) {
          console.log('abrirLead')
          this.loading = true
          let idsAtualizar = []
          selectedRecords.forEach((index) => {
            idsAtualizar.push(index.id)
          })
          console.log('idsAtualizar')
          console.log(idsAtualizar)
          api.post(`${getBaseUrl()}api/abrleads`, {
            idsData: idsAtualizar
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            this.loading = false
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data[0],
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              const routeData = this.$router.resolve(`/clientes/leads`)
              window.open(routeData.href, '_blank')
            })
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Favor selecionar alguma empresa para abrir um lead.",
            showConfirmButton: false,
            timer: 2500
          })
        }
      }
      else if (args.item.id === 'exportExcel') {
        this.loading = true
        const fileProps = {
          fileName: 'prospeccoes.xlsx'
        }
        this.$refs.dataGrid.excelExport(fileProps)
        this.loading = false
      }

      else if (args.item.text === 'exportCsv') {
        this.loading = true
        const fileProps = {
          fileName: 'prospeccoes.csv'
        }
        this.$refs.dataGrid.csvExport(fileProps)
        this.loading = false
      }
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="avisoDemonstracao"/>

    <Loader v-if="loading" style="min-height: 300px;">
    </Loader>

    <div v-if="!loading">
      <ejs-grid :dataSource="dataList"
                ref="dataGrid"
                :actionBegin="changePage"
                :allowFiltering="true"
                :allowPdfExport="true"
                :allowExcelExport="true"
                :allowPaging="true"
                :enableColumnVirtualization="true"
                :filterSettings="filterSettings"
                :toolbar="toolbar"
                :recordDoubleClick="recordDoubleClick"
                :toolbarClick="tbClickHandler"
                :dataBound="dataBound"
                :pageSettings="pageSettings"
                :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}"
                >
        <e-columns>
          <e-column headerText="Empresas" :columns="colsExib" textAlign="Center"></e-column>
        </e-columns>

        <template v-slot:templtcapital="{data}">
          <div> {{formatDecimal(data.capital)}} </div>
        </template>

      </ejs-grid>
    </div>

    <b-modal :title="'Detalhes Pessoa (' + pessoaData.id + ')'"
             size="xl"
             v-model="showModalPessoa" centered hide-footer>
      <div class="row">

        <div class="col-md-2">
          <div class="mb-3">
            <label for="cnpj">CNPJ</label>
            <input
                id="cnpj"
                v-model="pessoaData.cnpj"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="CNPJ"/>
          </div>
        </div>

        <div class="col-md-8">
          <div class="mb-3">
            <label for="nome">Nome</label>
            <input
                id="nome"
                v-model="pessoaData.nome"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Nome"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="capital">Capital</label>
            <input
                id="capital"
                v-model="pessoaData.capital"
                type="number"
                :disabled="true"
                class="form-control text-end"
                placeholder="Capital"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="matriz_filial">Matriz / Filial</label>
            <input
                id="matriz_filial"
                v-model="pessoaData.matriz_filial"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Matriz / Filial"/>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3">
            <label for="fantasia">Nome Fantasia</label>
            <input
                id="fantasia"
                v-model="pessoaData.fantasia"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Nome Fantasia"/>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3">
            <label for="endereco">Endereço</label>
            <input
                id="endereco"
                v-model="pessoaData.endereco"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Endereço"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="numero">Número</label>
            <input
                id="numero"
                v-model="pessoaData.numero"
                type="text"
                :disabled="true"
                class="form-control text-end"
                placeholder="Número"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="complemento">Complemento</label>
            <input
                id="complemento"
                v-model="pessoaData.complemento"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Complemento"/>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3">
            <label for="bairro">Bairro</label>
            <input
                id="bairro"
                v-model="pessoaData.bairro"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Bairro"/>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3">
            <label for="cidade">Cidade</label>
            <input
                id="cidade"
                v-model="pessoaData.cidade"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Cidade"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="cep">CEP</label>
            <input
                id="cep"
                v-model="pessoaData.cep"
                type="text"
                :disabled="true"
                class="form-control text-end"
                placeholder="CEP"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="estado">Estado</label>
            <input
                id="estado"
                v-model="pessoaData.estado"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Estado"/>
          </div>
        </div>

        <div class="col-md-10">
          <div class="mb-3">
            <label for="cnae">CNAE's</label>
            <input
                id="cnae"
                v-model="pessoaData.cnae"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="CNAE's"/>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-2">
          <div class="mb-3">
            <label for="natureza_cod">Código Natureza</label>
            <input
                id="natureza_cod"
                v-model="pessoaData.natureza_cod"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Código Natureza"/>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3">
            <label for="natureza">Natureza</label>
            <input
                id="natureza"
                v-model="pessoaData.natureza"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Natureza"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="motivo_cod">Código Motivo</label>
            <input
                id="motivo"
                v-model="pessoaData.motivo_cod"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Código Motivo"/>
          </div>
        </div>

        <div class="col-md-4">
          <div class="mb-3">
            <label for="motivo">Motivo</label>
            <input
                id="motivo"
                v-model="pessoaData.motivo"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Motivo"/>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-4">
          <div class="mb-3">
            <label for="email">E-mail</label>
            <input
                id="email"
                v-model="pessoaData.email"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="E-mail"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="telefone_1">Telefone 1</label>
            <input
                id="telefone_1"
                v-model="pessoaData.telefone_1"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Telefone 1"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="telefone_2">Telefone 2</label>
            <input
                id="telefone_2"
                v-model="pessoaData.telefone_2"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Telefone 2"/>
          </div>
        </div>

        <div class="col-md-2">
          <div class="mb-3">
            <label for="telefone_3">Telefone 3</label>
            <input
                id="telefone_2"
                v-model="pessoaData.telefone_3"
                type="text"
                :disabled="true"
                class="form-control"
                placeholder="Telefone 3"/>
          </div>
        </div>


      </div>
      <hr>

      <div class="row mt-2">

        <table class="table align-middle table-nowrap" >
          <thead class="table-light">
          <tr>
            <th class="align-middle">Nome</th>
            <th class="align-middle">CPF/CNPJ</th>
            <th class="align-middle">Entrada</th>
            <th class="align-middle">Fx.Etária</th>
            <th class="align-middle">Qualificação</th>
            <th class="align-middle">Rep.Legal</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="data in pessoaSociosData" :key="data.nome">
            <td>{{ data.nome }} </td>
            <td>{{ data.cnpj }} </td>
            <td>{{ data.entrada }} </td>
            <td>{{ data.faixaEtaria }} </td>
            <td>{{ data.qualif }} </td>
            <td>{{ data.repLegal }} </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPessoa = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>

      </div>
    </b-modal>


    <b-modal title="Detalhes Pesquisa"
             size="md"
             v-model="showModalPesquisa" centered hide-footer>

      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="cnpjPesq">CNPJ (Exato)</label>
            <input
                id="cnpjPesq"
                v-model="pesqData.cnpj"
                type="text"
                class="form-control"
                placeholder="CNPJ"/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="cnaePesq">CNAE (Exato)</label>
            <input
                id="cnaePesq"
                v-model="pesqData.cnae"
                type="text"
                class="form-control"
                placeholder="CNAE"/>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="cidadePesq">Cidade (Exato)</label>
            <input
                id="cidadePesq"
                v-model="pesqData.cidade"
                type="text"
                class="form-control"
                placeholder="Cidade"/>
          </div>
        </div>



        <div class="col-md-6">
          <div class="mb-3">
            <label for="estadoPesq">Estado (Exato)</label>
            <input
                id="estadoPesq"
                v-model="pesqData.estado"
                type="text"
                class="form-control"
                placeholder="Estado"/>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-12">
          <div class="mb-3">
            <label for="nomePesq">Razão Social (Aproximação)</label>
            <input
                id="nomePesq"
                v-model="pesqData.nome"
                type="text"
                class="form-control"
                placeholder="Razão Social"/>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-12">
          <div class="mb-3">
            <label for="socioPesq">Nome Sócio (Exato)</label>
            <input
                id="socioPesq"
                v-model="pesqData.socio"
                type="text"
                class="form-control"
                placeholder="Nome Sócio"/>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="bairroPesq">Bairro (Aproximação)</label>
            <input
                id="bairroPesq"
                v-model="pesqData.bairro"
                type="text"
                class="form-control"
                placeholder="Bairro"/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="ruaPesq">Rua (Aproximação)</label>
            <input
                id="ruaPesq"
                v-model="pesqData.rua"
                type="text"
                class="form-control"
                placeholder="Rua"/>
          </div>
        </div>

      </div>

      <hr>

      <div class="row">

        <div class="col-sm-6">
          <div class="mb-3">
            <label for="order">Ordenação</label>
            <select
                id="order"
                v-model="pesqData.order"
                class="form-control">
              <option value="capital">Capital</option>
              <option value="nome">Nome</option>
            </select>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="mb-3">
            <label for="sentido">Sentido</label>
            <select
                id="sentido"
                v-model="pesqData.sentido"
                class="form-control">
              <option value="asc">Crescente</option>
              <option value="desc">Decrescente</option>
            </select>
          </div>
        </div>

      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPesquisa = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarNovaPesq">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


  </Layout>
</template>

<style>

.sts-el {
  background-color: rgba(78,59,0,0.5);
}
.sts-cf {
  background-color: rgba(0,58,78,0.5);
}
.sts-enp {
  background-color: rgba(33,78,0,0.5);
}
.sts-ecr {
  background-color: rgba(146,20,0,0.5);
}
.sts-eat {
  background-color: rgba(146,20,0,0.5);
}
.sts-ned {
  background-color: rgba(146,73,0,0.5);
}
.sts-nef {
  background-color: rgba(146,20,0,0.5);
}
.sts-sct {
  background-color: rgba(146,111,0,0.5);
}
.sts-cct {
  background-color: rgba(0,58,78,0.5);
}
.sts-tra {
  background-color: rgba(146,20,0,0.5);
}
.sts-can {
  background-color: rgba(146,20,0,0.5);
}


</style>